<template>
  <div>
    <el-row type="flex" :gutter="15">
      <el-col>
        <el-row class="vertical-center-box title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <slot name="title">
              <span class="title-h4">{{title}}</span>
            </slot>
          </div>
          <div class="vertical-center-box">
            <w-check-obj-table-popup-button class="mr-r4" :checked-obj-list="objList" @change-obj-list="changeObjList"/>
          </div>
        </el-row>
        <el-table :data="objList">
          <el-table-column prop="objName" label="장비명" sortable/>
          <el-table-column prop="ipaddress" label="IP" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.ipaddress ? scope.row.ipaddress : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="event" width="145" label="이벤트 발생 중지" align="center" header-align="center" :render-header="renderEventHeader">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.exceptEvent"  true-label="Y" false-label="N" :disabled="scope.row.exceptResource == 'Y'"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="resource" width="95" label="수집 중지" align="center" header-align="center" :render-header="renderResourceHeader">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.exceptResource" true-label="Y" false-label="N" @change="exceptResourceChange(scope.row)"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { clone, forEach, isEmpty, cloneDeep, differenceWith, orderBy, isEqual } from 'lodash';
import WCheckObjTablePopupButton from '@/components/button/CheckObjTablePopupButton';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WWorkTargetView',
  components: {
    WCheckObjTablePopupButton,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columnDefault,
      objList: [],
      isExceptEvent: false,
      isExceptRsc: false,
      allCheckExceptEvent: false,
      allCheckExceptResource: false,
      originObjDatas: [],
      modifiedObjDatas: [],
      checkedRows: [],
      showSearchTool: false,
      title: '대상 목록',
    };
  },
  methods: {
    getWorkTarget() {
      this.isDirtyObjData();
      const resultMap = { objList: this.objList };
      if (this.modifiedObjDatas.length > 0) resultMap.modifiedObjDatas = this.modifiedObjDatas;
      return this.objList.length > 0 ? resultMap : false;
    },
    /**
     * 초기 값 설정 (부모 컴포넌트에서 호출) (추가/수정 팝업)
     * @author jeee12
     * @param  {[type]} workParams          수정팝업에서만 존재 (추가팝업에서는 x)
     */
    initWorkTarget(workParams) {
      if (isEmpty(workParams)) {
        this.objList = []; // 작업대상 초기화
        this.isExceptEvent = false;
        this.isExceptRsc = false;
      } else {
        const objList = workParams.objList;
        this.originObjDatas = cloneDeep(objList);
        this.objList = objList;
      }
    },
    renderEventHeader(h, { column }) {
      const me = this;
      const func = this.headerEventClick;
      const tempHeader = h(
        'el-checkbox',
        {
          on: {
            input(e) {
              if (e) {
                me.isExceptEvent = true;
                return;
              }
              me.isExceptEvent = false;
            },
            change() {
              func(column);
            },
          },
          class: 'table-header',
          props: {
            label: '이벤트 발생 중지',
            value: me.isExceptEvent,
            checked: me.isExceptEvent,
          },
        },
      );
      return tempHeader;
    },
    renderResourceHeader(h, { column }) {
      const me = this;
      const func = this.headerRscClick;
      const tempHeader = h(
        'el-checkbox',
        {
          on: {
            input(e) {
              if (e) {
                me.isExceptRsc = true;
                me.isExceptEvent = true;
                return;
              }
              me.isExceptRsc = false;
            },
            change() {
              func(column);
            },
          },
          class: 'table-header',
          props: {
            label: '수집 중지',
            value: me.isExceptRsc,
            checked: me.isExceptRsc,
          },
        },
      );
      return tempHeader;
    },
    headerEventClick(column) {
      if (column.property === 'event') {
        const checkFlag = clone(this.isExceptEvent) ? 'Y' : 'N';
        const tempObjList = cloneDeep(this.objList);
        forEach(tempObjList, (obj) => {
          obj.exceptEvent = checkFlag;
        });
        this.objList = tempObjList;
      }
    },
    headerRscClick(column) {
      if (column.property === 'resource') {
        const checkFlag = clone(this.isExceptRsc) ? 'Y' : 'N';
        const tempObjList = cloneDeep(this.objList);
        forEach(tempObjList, (obj) => {
          obj.exceptResource = checkFlag;
        });
        if (checkFlag) {
          forEach(tempObjList, (obj) => {
            obj.exceptEvent = checkFlag;
          });
        }
        this.isExceptEvent = clone(this.isExceptRsc);
        this.objList = tempObjList;
      }
    },
    /**
     * 작업대상 data 설정 (부모 컴포넌트에서 호출) (수정 팝업)
     * @author jeee12
     * @param  {[type]} workParams [description]
     */
    loadWorkTarget(workParams) {
      this.initWorkTarget(workParams);
      this.modifiedObjDatas = [];
    },
    /**
     * 작업대상 변경된 데이터 판별 (수정 팝업)
     * @author jeee12
     */
    isDirtyObjData() {
      const modifiedList = orderBy(this.objList, ['objId'], ['asc']);
      const originList = orderBy(this.originObjDatas, ['objId'], ['asc']);
      const deleteObjDatas = differenceWith(originList, modifiedList, isEqual).map((obj) => ({
        sqlType: 'DELETE',
        ...obj,
      }));
      const insertObjDatas = differenceWith(modifiedList, originList, isEqual).map((obj) => ({
        sqlType: 'INSERT',
        ...obj,
      }));
      const objList = [...deleteObjDatas, ...insertObjDatas];
      this.modifiedObjDatas = objList;
    },
    changeObjList(objList) {
      this.objList = cloneDeep(objList);
    },
    exceptResourceChange(row) {
      if (row.exceptResource === 'Y') {
        row.exceptEvent = 'Y';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/work/popup/components/WorkTargetView.vue